/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import Direction from '../../icons/Direction';


const DirectionButton = ({ className, invert, onClick }) => (
  <div
    className={className}
    style={{
      width: '15px',
      transform: `scaleX(${invert ? -1 : 1})`,
    }}
    onClick={onClick}
    onKeyPress={onClick}
    role="button"
    tabIndex={0}
  >
    <Direction />
  </div>
);


DirectionButton.defaultProps = {
  className: null,
  invert: false,
  onClick: () => {},
};

DirectionButton.propTypes = {
  className: PropTypes.string,
  invert: PropTypes.bool,
  onClick: PropTypes.func,
};


export const PreviousButton = props => <DirectionButton {...props} />;
export const NextButton = props => <DirectionButton invert {...props} />;
